import React from "react";
import { useSelector, useDispatch } from "react-redux";
import GuessButton from "../GuessButton";
import ResetNewsieButton from "../ResetNewsieButton";
import "./GameDetails.css";

import { resetActiveNewsie } from "../../../redux/features/gameSlice";

const GameDetails = () => {
  const dispatch = useDispatch();
  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );

  const incorrectGuesses = useSelector(
    (state: any) => state.gameReducer.incorrectGuesses[selectedNewsie]
  );

  const time = useSelector((state: any) =>
    state.gameReducer.timer && state.gameReducer.timer[selectedNewsie]
      ? state.gameReducer.timer[selectedNewsie].time
      : -1
  );

  const guessable = useSelector((state: any) => state.gameReducer.guessable);
  const gameOver = useSelector(
    (state: any) => state.gameReducer.gameOver[selectedNewsie]
  );
  const winner = useSelector(
    (state: any) => state.gameReducer.winner[selectedNewsie]
  );
  const completedLoserDiscovery = useSelector(
    (state: any) => state.gameReducer.completedLoserDiscovery[selectedNewsie]
  );
  const loser = useSelector(
    (state: any) => state.gameReducer.loser[selectedNewsie]
  );

  const SCORE = 1000 - time - 10 * incorrectGuesses;

  const handleClickReset = () => {
    dispatch(resetActiveNewsie());
  };

  return (
    <div className="game-details">
      <GuessButton
        guessable={guessable}
        gameOver={gameOver}
        won={winner}
        incorrectGuesses={incorrectGuesses}
        time={time}
        score={SCORE}
      />
      {loser && (
        <ResetNewsieButton
          onClickReset={handleClickReset}
          completedLoserDiscovery={completedLoserDiscovery}
        />
      )}
    </div>
  );
};

export default GameDetails;
